<template>
	<div  class="create-offer page">
		<div class="create-offer-body" >
			<div class="create-offer-body-left">
				<div class="create-offer-title m-b-15">
					Sample Theme
				</div>
				<div class="create-offer-form m-t-30">
					<div class="row">
						<div class="col col-6">
							<router-link class="btn btn-back" :to="{ name : 'Sample'}">
								<i class="fas fa-chevron-left"></i>Back
							</router-link>
						</div>
						<div class="col col-6">
							<div class="text-right m-b-30">
								<button class="btn btn-primary" :class="{ 'is-loading' : is_saving_theme }" @click.stop.prevent="saveTheme">Save as template</button>
							</div>
						</div>
					</div>
					<offer-theme :is-sample="true"  :formstate="formstate" :validate="$v.form.theme" v-model="form.theme"></offer-theme>
				
				</div>
			</div>
			<div class="create-offer-body-right">
				<div class="vue-offer-preview">
					<div class="create-offer-title" >
						Preview
					</div>
					<div class="box-preview box-preview-fixed">
						<div class="box-preview-header">
							<div class="box-preview-image">
								<img src="@/assets/images/sample/sample.jpg" alt="">
							</div>
							<div class="box-preview-title">
								Product Demo
							</div>
							<div class="box-preview-cart">
								Add to cart
							</div>
						</div>
						<div class="box-preview-body">
							<offer-preview :message="defaultData.message" :theme="form.theme.theme_setting"></offer-preview>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import OfferTheme from '@/views/offers/partials/offer-theme'
import OfferPreview from '@/views/offers/partials/offer-preview'
import OfferShortcode from '@/views/offers/partials/offer-shortcode'
import VueModal from '@/components/vue-modal'
import { required, requiredIf , minValue } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
export default {
	name : 'OfferForm',
	components:{
		OfferTheme,
		OfferPreview,
		OfferShortcode,
	},
	data(){
		return {
			is_active : 'content',
			is_error : false,
			is_loading_page : false,
			is_loading : false,
			is_loading_status : false,
			is_edit_mode : false,
			is_publish : false,
			is_modify: false,
			update_id : null,
			show_modal: false,
			allow_modal_backdrop: true,
			allow_products: [],
			formstate : false,
			is_saving_message: false,
			is_saving_theme: false,
			form : {
				"theme":{
					"theme_setting": {
						"config" :{
							"background_type" : "solid",
							"show_border" : true,
							"show_box_shadow" : true,
							"link_underline" : true,
							"link_hover" : true
						},
						"style": {
							"--salesbox-background-color" : "#FFFFFF",
							"--salesbox-background-pattern" : '',
							"--salesbox-background-pattern-position" :'center center',
							"--salesbox-background-image" : '',
							"--salesbox-background-image-default" : '',
							"--salesbox-background-image-size" :'cover',
							"--salesbox-background-image-position" :'center center',
							"--salesbox-background-image-position-default" :'center center',
							"--salesbox-border-style" : "solid",
							"--salesbox-border-color" : "#ccc",
							"--salesbox-border-width" : "1px",
							"--salesbox-border-radius" : "1px",
							"--salesbox-font-family" : "inherit",
							"--salesbox-font-size" : "13px",
							"--salesbox-color" : "#000",
							"--salesbox-shortcode-font-size" : "13px",
							"--salesbox-shortcode-color" : "#222",
							"--salesbox-label-font-size" : "15px",
							"--salesbox-label-color" : "#222",
							"--salesbox-link-color-hover" : "#000",
							"--salesbox-link-decoration" : "underline",
							"--salesbox-box-shadow" :  "0px 0px 15px rgba(0, 0, 0, 0.1)",
						},
					},
					"background_image_base64":'',
					"is_custom_css": false,
					"custom_css": "",
				},
			}
		}
	},
	computed:{
		...mapGetters({
			preview_url : 'auth/getShopPreviewUrl',
			defaultData : 'offer/getDefaultData'
		}),
	},
	methods:{
		...mapActions({
			create : 'setting/createSample',
		}),
		changeTab(tab){
			this.is_active = tab
		},
		saveTheme(){
			if( !this.is_saving_theme && !this.$v.form.theme.$invalid){
				this.is_saving_theme = true;
				this.create({
					type : 'theme',
					data : this.form.theme
				})
				.then((res)=>{
					let { status } = res.data 
					if( status ){
						this.$toast({
							title: "",
							message:'Create sample successfully !',
							icon: "fal fa-check",
							type: 'success',
							time : 2000
						});
						this.redirect({
							name : 'Sample',
							query :{
								type : 'theme'
							}
						})
					}
				})
				.finally(()=>{
					this.is_saving_theme = false
				})
			}
		},
	},
	created(){
		this.is_loading_page = false 
		if( this.form.id && this.form.message_type == 'product'){
			this.allow_products = this.form.products.map((item)=>item.id)
		}
		this.$watch('form',{
			handler: function(newValue) {
				this.is_modify = true
			},
			deep: true
		})
	},
	validations(){
		var vm = this 
		return  {
			form : {
				theme : {
					theme_setting : {
						style  :{
							"--salesbox-background-color" : {
								required : requiredIf( function(){
									return vm.form.theme.theme_setting.config.background_type == 'solid'
								})
							},
							"--salesbox-background-image" : {
								required : requiredIf( function(){
									return vm.form.theme.theme_setting.config.background_type == 'image'
								})
							},
							"--salesbox-border-color" : {
								required : requiredIf( function(){
									return vm.form.theme.theme_setting.config.show_border
								})
							},
							"--salesbox-color" : {
								required 
							},
							"--salesbox-shortcode-color" : {
								required 
							},
							"--salesbox-label-color" : {
								required 
							},
							"--salesbox-link-color-hover" : {
								required : requiredIf( function(){
									return vm.form.theme.theme_setting.config.link_hover
								})
							},
						}
					},
					"message_custom_element" : {
						required : requiredIf( function(){
							return vm.form.theme.message_position_type == 'custom_element'
						})
					},
				}
			}
		}
	}
}
</script>
<style lang="scss" >
	
	.create-offer{
		&-title{
			font-weight: bold;
			font-size: 18px;
			color: #39332E;
		}
		&-body{
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			transition: all 0.3s ease;
			&-left{
				@include flex(58%);
				background: #fff;
				padding: 15px 50px;
				h4{
					font-weight: bold;
					font-size: 13px;
					line-height: 18px;
					margin: 0;
				}
			}
			&-right{
				@include flex(42%);
				background: #F4F4F4;
				padding: 15px 50px;
				.box-preview{
					border: 1px solid #eee;
					background: #fff;
					padding: 24px;
					box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
					border-radius: 4px;
					&-header{
						
					}
					&-image{
						img{
							max-width: 100%;
						}
					}
					&-title{
						font-style: normal;
						font-weight: 600;
						font-size: 13px;
						color: #000000;
						display: block;
						text-align: center;
					}
					&-cart{
						background: #D4D4D4;
						border-radius: 4px;
						display: flex;
						align-items: center;
						justify-content: center;
						height: 32px;
						font-style: normal;
						font-weight: 600;
						font-size: 13px;
						color:#fff;
						margin-top: 20px;
					}
					&-body{
						margin-top: 20px;
					}
				}
			}
		}
		.modal-create-offer{
			.modal-create-offer{
				&-header{
					font-weight: bold;
					font-size: 18px;
					line-height: 25px;
					color: $primary;
					border-bottom: 1px solid #eee;
					padding: 15px;
					
				}
				&-body{
					text-align: center;
					padding: 15px;
					font-size: 13px;
					transition: all 0.3s ease;
					p{
						margin-bottom: 5px;
					}
					h3{
						font-weight: bold;
						font-size: 24px;
						margin-bottom: 15px;
					}
					.btn{
						font-weight: 600;
					}
					.btn-link{
						color:#92929C;
						font-weight: 600;
					}
					&-success{
						padding-top: 30px;
					}
				}
				&-footer{
					border-top: 1px solid #eee;
					padding: 15px;
				}
			}
		}
		&-tabs{
			border-bottom: 1px solid #eee;
		}
		.text-error{
			color:$red;
			margin-top: 10px;
			font-size: 13px;
		}
	}
</style>